import React, { useEffect, useMemo } from 'react';
import { CalculationStatisticStoreSourceResponse } from '@ydistri/api-sdk';
import { useCurrency } from '../../../../hooks/useCurrency';
import { useApplicationData } from '../../../../hooks/useApplicationData';
import PrefilledTableSourceStore from '../../Statistics/modal/SourceStore/PrefilledTableSourceStore';
import { buildSourceStoreStats } from './sourceStoreStats';
import { ChangelogSectionProps, parseChangelogData } from '../editRedistributionLib';

const ChangelogSourceStores: React.FC<ChangelogSectionProps> = ({
  stringifiedData,
  onStatsComputed,
}) => {
  const currency = useCurrency();
  const { departments: hasDepartments } = useApplicationData();

  const data = useMemo(
    () => parseChangelogData<CalculationStatisticStoreSourceResponse>(stringifiedData),
    [stringifiedData],
  );

  const useDepartments = data.some(i => i.department);

  useEffect(() => {
    onStatsComputed(buildSourceStoreStats(data, hasDepartments, currency));
  }, [data, hasDepartments, currency, onStatsComputed]);

  if (data.length === 0) return null;

  return (
    <PrefilledTableSourceStore data={data} displayDepartment={hasDepartments && useDepartments} />
  );
};

export default ChangelogSourceStores;
